import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  professionalCategory?: string
}

const ProfessionalCategory = ({ professionalCategory }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.spain.professional_category')}
      description={professionalCategory}
    />
  )
}

export default ProfessionalCategory
